import { MealItemType } from 'models/production-report.model';
import React, { useEffect, useState } from 'react';
import './styles.scss';
import { MenuHorizontalIcon } from 'cokitchen-icons';
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';
import {
  Dropdown,
  DropdownItem,
  DropdownList,
  ToastMessage
} from '@cokitchen/cokitchen-components';
import { STORAGE_KEYS } from 'utils/constants';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import FinishMealProductionModal from 'components/modals/finish-meal-production-modal';
import EditMealModal from 'components/modals/edit-meal-modal';

type Props = {
  meal: MealItemType;
  selectedMeals: MealItemType[];
  setSelectedMeals: (meals: MealItemType[]) => void;
  refetchMeals: () => void;
  updateMeals: (data: Partial<MealItemType>) => void;
};
const MealCard = ({ meal, selectedMeals, setSelectedMeals, refetchMeals, updateMeals }: Props) => {
  const lowQuantity = meal.minimun_stock_level >= meal.quantity;
  const [showMenu, setShowMenu] = useState(false);
  const [checked, setChecked] = useState(false);
  const [start, setStart] = useState(false);
  const [showFinishProductionModal, setShowFinishProductionModal] = useState(false);
  const [showEditMealModal, setShowEditMealModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN);

  useEffect(() => {
    if (checked) {
      setSelectedMeals([...selectedMeals, meal]);
    } else {
      setSelectedMeals(selectedMeals.filter((item) => item.id !== meal.id));
    }
  }, [checked]);

  useEffect(() => {
    if (selectedMeals.includes(meal)) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [selectedMeals]);
  useEffect(() => {
    if (meal.production_status === 1) {
      setStart(true);
    }
  }, [meal]);

  const startMealProduction = async () => {
    const data = {
      cokitchen_id: cokitchenId,
      kitchen_item_id: meal.kitchen_item_id
    };
    try {
      setLoading(true);
      const res = await apiService.post(`production-history/production/start`, {
        data,
        useToken: true
      });
      if (res) {
        setStart(true);
        toast(<ToastMessage message='Meal production started successfully' type='success' />);
      }
    } catch (error: any) {
      toast(
        <ToastMessage
          message={error.response.data.message || 'Meal production failed'}
          type='error'
        />
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEditMeal = () => {
    setShowEditMealModal(true);
  };

  const handleClick = () => {
    if (loading) return;
    if (!start) {
      startMealProduction();
    } else {
      setShowFinishProductionModal(true);
    }
  };
  return (
    <div>
      <div className='p-[2px] h-[126px] mb-4 meal_card'>
        <div className='px-3 pt-[14px] h-full pb-2 bg-white rounded-lg border border-[#313435'>
          <div className='flex gap-3 lg:gap-5 w-full'>
            <div
              className={`w-[56px] h-[46px] rounded ${
                lowQuantity ? 'bg-[#FEE2E5]' : 'bg-[#F4F1F2]'
              } quantity_box`}>
              <p className={`${lowQuantity ? 'text-red-5' : 'text-gray-6'} font-medium`}>
                {meal.quantity}
              </p>
              <p className='text-[#5E6164] text-2xs'> Qty left</p>
            </div>
            <div className='flex text-[#2E3031] justify-between gap-3 meal_info'>
              <div>
                <p className='text-sm font-medium capitalize line-clamp-1'>
                  {meal.kitchen_item?.name}
                </p>
                <p className='text-[#6F7376] text-xs'>{meal.quantity} portions produced</p>
              </div>
              <Dropdown
                visible={showMenu}
                onClickOutside={() => setShowMenu(false)}
                content={
                  <MenuHorizontalIcon
                    className='cursor-pointer'
                    onClick={() => setShowMenu(true)}
                  />
                }>
                <DropdownList>
                  <DropdownItem onClick={handleEditMeal}>Edit kitchen item</DropdownItem>
                </DropdownList>
              </Dropdown>
            </div>
          </div>
          <div className='flex gap-2 items-center mt-4 mb-2'>
            <div
              className={`w-full rounded cursor-pointer ${
                start ? 'bg-red-5' : 'bg-[#F2F2F3]'
              } h-[34px] flex justify-center items-center ${loading && 'cursor-not-allowed'}`}
              onClick={handleClick}>
              <p className={`${start ? 'text-white' : 'text-[#5E6164]'} text-sm`}>
                {start ? 'Finish' : 'Start'}
              </p>
            </div>
            <div
              className={`w-[34px] h-[34px] rounded cursor-pointer ${
                checked ? 'bg-red-5' : 'bg-[#F2F2F3]'
              } flex justify-center items-center`}
              onClick={() => setChecked(!checked)}>
              <CheckIcon
                className={`w-[18px] h-[18px] ${checked ? 'checked_icon' : 'unchecked_icon'}`}
              />
            </div>
          </div>
        </div>
      </div>
      <FinishMealProductionModal
        isOpen={showFinishProductionModal}
        onClose={() => {
          setShowFinishProductionModal(false);
        }}
        meal={meal}
        refetchMeals={refetchMeals}
      />
      {showEditMealModal && (
        <EditMealModal
          isOpen={showEditMealModal}
          onClose={() => setShowEditMealModal(false)}
          meal={meal}
          updateMeals={updateMeals}
        />
      )}
    </div>
  );
};

export default MealCard;
